var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnicianIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "build_black_24dp 1",
    clipPath: "url(#clip0_1702_5033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.56 1.93997C7.22 0.59997 5.21334 0.326636 3.6 1.1133L6.02 3.5333C6.28 3.7933 6.28 4.2133 6.02 4.4733L4.96 5.5333C4.7 5.79997 4.28 5.79997 4.02 5.5333L1.6 3.1133C0.820002 4.7333 1.09334 6.72664 2.43334 8.06664C3.67334 9.30664 5.48667 9.6333 7.02667 9.0533L12.3333 14.36C13.02 15.0466 14.1267 15.0466 14.8067 14.36C15.4933 13.6733 15.4933 12.5666 14.8067 11.8866L9.52667 6.59997C10.14 5.03997 9.82 3.19997 8.56 1.93997Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1702_5033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicianIcon);
export default __webpack_public_path__ + "static/media/technicianIcon.3c8d117dcb847f8b975ddbf3f25071f4.svg";
export { ForwardRef as ReactComponent };